import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";
import { Link, Redirect, useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function Order() {
    const url = config.baseUrl;

    const [order, setOrder] = useState(null); // Adjust to handle null for initial state
    const [tab, setTab] = useState("details");
    const [editMode, setEditMode] = useState(false);

    // Get order ID from URL
    const orderId = window.location.pathname.split("/").pop();

    // Fetch order data
    useEffect(() => {
        axios
            .get(`${url}/orders/${orderId}`)
            .then((response) => setOrder(response.data))
            .catch((error) => console.error(error));
    }, [orderId]);

    // Handle form input changes
    const handleInputChange = (e) => {
        setEditMode(true);
        const { name, value } = e.target;
        setOrder((prevOrder) => ({
            ...prevOrder,
            [name]: value,
        }));
    };

    const handleUpdate = () => {
        setEditMode(!editMode);
        console.log("Send a PUT request to update order details");
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        axios
            .put(`${url}/orders/${orderId}`, order)
            .then((response) => {
                setEditMode(false);
                alert("Order details updated successfully!");
            })
            .catch((error) => console.error(error));
    };

    if (!order) {
        return <p>Loading order details...</p>;
    }

    return (
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded">
            <div className="rounded-t mb-0 px-4 py-3 border-0 bg-white min-h-screen">
                <div className="flex flex-wrap items-center">
                    <div className="relative w-full px-4 max-w-full flex-grow flex-1 flex justify-between">
                        <h3 className="font-semibold text-lg text-blueGray-700">
                            Order Information
                        </h3>
                        <button
                            className={`px-4 py-2 rounded ${editMode ? "btn-primary" : "btn-primary-disabled"
                                }`}
                            onClick={handleUpdate}
                            disabled={!editMode}
                        >
                            UPDATE
                        </button>
                    </div>
                </div>

                {/* Tab Navigation */}
                <div className="my-4">
                    <nav className="flex space-x-4 border-b-2 pb-2 overflow-x-scroll">
                        {["details", "order items", "Payments History"].map((t) => (
                            <button
                                key={t}
                                className={`px-3 py-2 rounded border-0 ${tab === t ? "bg-gray-200" : ""
                                    }`}
                                onClick={() => setTab(t)}
                            >
                                {t.charAt(0).toUpperCase() + t.slice(1)}
                            </button>
                        ))}
                    </nav>
                </div>

                {/* Tab Content */}
                <div className="block w-full overflow-x-auto">
                    {tab === "details" && (
                        <>
                            <h4 className="font-bold mb-4">Order Summary</h4>
                            <div className="flex flex-wrap -mx-2">
                                {/* Order ID Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Order Type</label>
                                    <input
                                        type="text"
                                        name="order_id"
                                        value={order.order_type}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled
                                    />
                                </div>

                                {/* Order Status Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Order Status</label>
                                    <input
                                        type="text"
                                        name="order_status"
                                        value={order.order_status}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>

                                {/* Payment Status Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Payment Status</label>
                                    <input
                                        type="text"
                                        name="payment_status"
                                        value={order.payment_status}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>

                                {/* Total Amount Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Total Amount</label>
                                    <input
                                        type="text"
                                        name="total_amount"
                                        value={order.order_total}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>
                            </div>

                            <h4 className="font-bold mb-4">Customer Details</h4>
                            <div className="flex flex-wrap -mx-2">
                                {/* Customer Name Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Customer Name</label>
                                    <input
                                        type="text"
                                        name="customer_name"
                                        value={order.customer?.name || ""}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>

                                {/* Order Date Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Order Date</label>
                                    <input
                                        type="text"
                                        name="order_date"
                                        value={order.order_date}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>

                                {/* Email Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={order.customer?.email || ""}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>

                                {/* Phone Input */}
                                <div className="mb-4 w-full sm:w-6/12 px-2 flex flex-col">
                                    <label className="text-sm text-gray-600">Phone</label>
                                    <input
                                        type="text"
                                        name="email"
                                        value={order.customer?.phone || ""}
                                        onChange={handleInputChange}
                                        className="form-input"
                                        disabled={!editMode}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {tab === "order items" && (
                        <>
                            <h4 className="font-bold mb-4">Order Items</h4>
                            <table className="table-auto w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border px-4 py-2 text-left">#</th>
                                        <th className="border px-4 py-2 text-left">Product</th>
                                        <th className="border px-4 py-2 text-left">Price</th>
                                        <th className="border px-4 py-2 text-left">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.order_items?.map((item, index) => (
                                        <tr key={item.order_item_id}>
                                            <td className="border px-4 py-2">{index+1}</td>
                                            <td className="border px-4 py-2">{item.product_name}</td>
                                            <td className="border px-4 py-2">{item.product_price}</td>
                                            <td className="border px-4 py-2">{item.product_quantity}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}

                    {tab === "Payments History" && (
                        <>
                            <div className="flex justify-between mb-2">
                                <h4 className="font-bold mb-4">Payment History</h4>

                                <button
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                >
                                    <Link to={'/admin/payments/create'}>Add New</Link>
                                </button>
                            </div>
                            <table className="table-auto w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border px-4 py-2">Transaction ID</th>
                                        <th className="border px-4 py-2">Payment Method</th>
                                        <th className="border px-4 py-2">Amount</th>
                                        <th className="border px-4 py-2">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.payments?.map((payment) => (
                                        <tr key={payment.payment_id}>
                                            <td className="border px-4 py-2 text-center">{payment.transaction_id}</td>
                                            <td className="border px-4 py-2 text-center">{payment.payment_method}</td>
                                            <td className="border px-4 py-2 text-center">{payment.amount_paid}</td>
                                            <td className="border px-4 py-2 text-center">{payment.payment_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
